import { Box, Breadcrumbs, Button, FormControl, Grid, MenuItem, Select, styled, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useDispatch } from 'react-redux';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import { currencyOptions, useCommonStyles } from '../../utils';
import { BUCKET_URL } from '../../ApiSetUp/AuthApi';
import IconBackground from '../Common/IconBackground';
import StyledTableRow from '../Common/StyledTableRow';
import StyledTableCell from '../Common/StyledTableCell';
import NoDataFound from '../Common/NoDataFound';
import { standardDateFormat } from '../../lib/standardDateFormat';
import { updatePurchaseEntry } from '../../Redux/Actions/PurchaseEntry';
import ErrorHandler from '../../lib/errorHandler';
import CommonTextField from '../Common/CommonTextField';
import ErrorMessage from '../Common/ErrorMessage';
import { useAppSelector } from '../../Redux/app/hooks';

const KeyName = styled('div')(({ theme }) => ({
    fontSize: '14px',
    fontFamily: 'Satoshi-Light',
}));

const Answer = styled('div')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'Satoshi-Medium',
}));

const ViewGrnNumber = ({ setIsViewGrnNumber, selectedItem, setSelectedItem, _getGRNNumber, setSearchValue }) => {
    // ============== Hooks ==============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // ============== States ==============
    const [error, setError] = useState({});
    const [isAnyItemStatusPartiallyAcceptOrReject, setIsAnyItemStatusPartiallyAcceptOrReject] = useState(false);

    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);
    // ============== validation ==============
    const validstep = () => {
        let error = {};
        let formIsValid = true;
        if (isAnyItemStatusPartiallyAcceptOrReject) {
            if (!selectedItem?.GRNDescription) {
                formIsValid = false;
                error.remark = "Please enter remark."
            }
        }

        const partiallyAcceptedItems = selectedItem?.purchaseOrder?.filter(
            (item) => item?.status === "Partially Accept"
        );
        partiallyAcceptedItems?.forEach((item, index) => {
            const accepted = Number(item?.acceptedQuantity);
            const rejected = Number(item?.rejectedQuantity);
            const supply = Number(item?.supplyQuantity);

            if (!accepted && !rejected) {
                formIsValid = false;
                setSnackBar('error', `Please enter accepted and rejected quantities for item ${index + 1}`);
            } else if (accepted <= 0 || rejected <= 0) {
                formIsValid = false;
                setSnackBar('error', `Accepted and rejected quantities must be greater than 0 for item ${index + 1}`);
            }
            else if (accepted + rejected !== supply) {
                formIsValid = false;
                setSnackBar('error', `Accepted + Rejected quantity must equal Supply Quantity for item ${index + 1}`);
            }
        });

        setError(error)
        return formIsValid
    }

    // ============== Handler ==============

    const tabelHeader = [
        "SR.",
        "Item(s)",
        "Unit",
        "Supply Quantity",
        "Accepted Quantity",
        "Rejected Quantity",
        "Status"
    ]

    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => { setIsViewGrnNumber(false); setSelectedItem({}); setSearchValue("") }}>
            GRN Number List
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            {`GRN Number`}
        </Typography>,
    ];

    const handleChangeInput = (index, value, name) => {
        const updatedData = selectedItem?.purchaseOrder?.map((ele, i) => {
            if (index == i) {
                return {
                    ...ele,
                    [name]: value,
                }
            } else {
                return {
                    ...ele
                }
            }
        })
        setSelectedItem({ ...selectedItem, purchaseOrder: updatedData })
    }
    const removeKeys = ["isActive", "isDeleted", "createdAt", "createdBy", "updatedBy", "updatedAt", "__v", "vendorDetail"];
    // ============= update Purchase Entry API =============
    const _updatePurchaseEntry = async () => {
        if (validstep()) {
            setFullPageLoader(true);
            let response;

            const filteredBody = Object.entries(selectedItem).reduce((acc, [key, value]) => {
                if (!removeKeys.includes(key)) {
                    acc[key] = key === "GRNDescription" && !isAnyItemStatusPartiallyAcceptOrReject ? null : value;
                }
                return acc;
            }, {});

            response = await dispatch(updatePurchaseEntry(filteredBody));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    setSnackBar("success", response?.payload?.message)
                    setIsViewGrnNumber(false)
                    setSelectedItem({})
                    setSearchValue("")
                    _getGRNNumber()
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        }
    };

    useEffect(() => {
        const temp = selectedItem?.purchaseOrder?.some(
            (ele) => ele?.status === "Partially Accept" || ele?.status === "Reject"
        );
        setIsAnyItemStatusPartiallyAcceptOrReject(temp)
    }, [selectedItem])

    return (
        <Grid container padding={"25px"} spacing={2} height={"fit-content"}>
            <Grid item xs={12}>
                <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>{`GRN Number`}</Typography>
                <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                >
                    {breadcrumbs}
                </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{ bgcolor: theme.palette.bgWhite.main, borderRadius: "26px", maxHeight: "64vh", overflowY: "auto", padding: "25px" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} display={'flex'} gap={2} alignItems={'end'} flexWrap={'wrap'}>
                            <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}>GRN Number</Typography>
                            {selectedItem?.GRNNUmber &&
                                <Typography fontFamily={"Satoshi-Light"} fontSize={"16px"}>GRN No: <span style={{ fontFamily: "Satoshi-Medium" }}>{selectedItem?.GRNNUmber}</span></Typography>
                            }
                            {selectedItem?.createdAt &&
                                <Typography fontFamily={"Satoshi-Light"} fontSize={"16px"}>GRN Date: <span style={{ fontFamily: "Satoshi-Medium" }}>{selectedItem?.createdAt && standardDateFormat(selectedItem?.createdAt)}</span></Typography>
                            }
                        </Grid>
                        <Grid container item spacing={3} sx={{ display: "flex", justifyContent: { xs: "start", md: "space-between" } }}>
                            <Grid item>
                                <KeyName>Vendor</KeyName>
                                <Answer>{selectedItem?.vendorName ? selectedItem?.vendorName : "NA"}</Answer>
                            </Grid>
                            {/* <Grid item>
                                <KeyName>PO Number</KeyName>
                                <Answer>{selectedItem?.poNumber ? selectedItem?.poNumber : "NA"}</Answer>
                            </Grid> */}
                            {selectedItem?.vendorDetail?.vendorType &&
                                <Grid item>
                                    <KeyName>Type</KeyName>
                                    <Answer>{selectedItem?.vendorDetail?.vendorType == 1 ? "Local" : "Import"}</Answer>
                                </Grid>
                            }
                            <Grid item>
                                <KeyName>Invoice Number</KeyName>
                                <Answer>{selectedItem?.invoiceNumber ? selectedItem?.invoiceNumber : "NA"}</Answer>
                            </Grid>
                            <Grid item>
                                <KeyName>Invoice Date</KeyName>
                                <Answer>{selectedItem?.invoiceDate ? standardDateFormat(selectedItem?.invoiceDate) : "NA"}</Answer>
                            </Grid>
                            {selectedItem?.testCertificateDocument &&
                                <Grid item>
                                    <KeyName>Test Certificate</KeyName>
                                    <Box display="flex" flexWrap={"wrap"} alignItems={"center"} gap={1} mt={1}>
                                        <Answer>
                                            {selectedItem?.testCertificateDocument?.split("/").pop()}
                                        </Answer>
                                        <IconBackground icon="visibility" size='30px' onClick={() => window?.open(`${BUCKET_URL + selectedItem?.testCertificateDocument}`)} />
                                    </Box>
                                </Grid>
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                <TableContainer>
                                    <Table >
                                        <TableHead>
                                            <StyledTableRow isHeader isBordered style={{ backgroundColor: "#E9E9E9" }}>
                                                {tabelHeader?.map((ele) => {
                                                    return (
                                                        <StyledTableCell align='center'>{ele}</StyledTableCell>
                                                    )
                                                })}
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {selectedItem?.purchaseOrder?.length > 0 ?
                                                selectedItem?.purchaseOrder?.map((row, index) => {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <StyledTableRow noColor isBordered>
                                                                <StyledTableCell isBordered>
                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                        {index + 1}
                                                                    </Box>
                                                                </StyledTableCell>
                                                                <StyledTableCell isBordered >
                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Box backgroundColor="#F7FAFC" sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                            <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{row?.itemName ? row?.itemName : "NA"}</Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </StyledTableCell>
                                                                <StyledTableCell isBordered >
                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Box backgroundColor="#F7FAFC" sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                            <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{selectedItem?.unitType ? selectedItem?.unitType : "NA"}</Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </StyledTableCell>
                                                                {/* <StyledTableCell isBordered >
                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Box backgroundColor="#F7FAFC" sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                            <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{row?.quantity ? row?.quantity : "NA"}</Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </StyledTableCell> */}
                                                                <StyledTableCell isBordered >
                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Box sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                            <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{row?.supplyQuantity ? row.supplyQuantity : "NA"}</Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </StyledTableCell>
                                                                {/* <StyledTableCell isBordered >
                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Box sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                            <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{row?.subTotal ? `${currencyOptions?.find((ele) => ele?.name == selectedItem?.moneyType)?.symbol} ${row?.subTotal}` : "NA"}</Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </StyledTableCell> */}

                                                                <StyledTableCell isBordered align='center'>
                                                                    {row?.status === "Partially Accept" ?
                                                                        <CommonTextField
                                                                            width={"80px"}
                                                                            type="number"
                                                                            name="acceptedQuantity"
                                                                            value={row?.acceptedQuantity}
                                                                            placeholder="Ex. 10"
                                                                            sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                            onChange={(e) => {
                                                                                if (+e?.target?.value >= 0) {
                                                                                    handleChangeInput(index, +e.target.value, "acceptedQuantity")
                                                                                } else {
                                                                                    return;
                                                                                }
                                                                            }}
                                                                        />
                                                                        :
                                                                        row?.status === "Accept" ?

                                                                            <Box sx={{ display: "flex", justifyContent: "center" }}>

                                                                                <Box sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                                    <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{row?.supplyQuantity}</Typography>
                                                                                </Box>
                                                                            </Box>
                                                                            :
                                                                            "NA"
                                                                    }
                                                                </StyledTableCell>
                                                                <StyledTableCell isBordered align='center'>
                                                                    {row?.status === "Partially Accept" ?
                                                                        <CommonTextField
                                                                            width={"80px"}
                                                                            type="number"
                                                                            name="rejectedQuantity"
                                                                            value={row?.rejectedQuantity}
                                                                            placeholder="Ex. 10"
                                                                            sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                            onChange={(e) => {
                                                                                if (+e?.target?.value >= 0) {
                                                                                    handleChangeInput(index, +e.target.value, "rejectedQuantity")
                                                                                } else {
                                                                                    return;
                                                                                }
                                                                            }}
                                                                        />
                                                                        :
                                                                        row?.status === "Accept" ?
                                                                            "NA"
                                                                            :
                                                                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                                <Box sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                                    <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{row?.supplyQuantity}</Typography>
                                                                                </Box>
                                                                            </Box>
                                                                    }
                                                                </StyledTableCell>
                                                                <StyledTableCell isBordered align='center'>
                                                                    <Box display={'flex'} justifyContent={"center"} alignItems={"center"} gap={2}>
                                                                        <FormControl size="small">
                                                                            <Box
                                                                                sx={{
                                                                                    position: "relative",
                                                                                    display: "inline-block",
                                                                                    borderRadius: "30px",
                                                                                    width: "fit-content",
                                                                                    padding: "3px",
                                                                                    "&::before": {
                                                                                        content: '""',
                                                                                        position: "absolute",
                                                                                        inset: 0,
                                                                                        borderRadius: "30px",
                                                                                        padding: "2px",
                                                                                        background: row?.status === "Accept" ? "linear-gradient(to top, #10B981, #10B98100)" : row?.status === "Partially Accept" ? "linear-gradient(to top, #FFA62B, #FFA62B00)" : "linear-gradient(to top, #EF4444, #EF444400)",
                                                                                        WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                                                                                        WebkitMaskComposite: "destination-out",
                                                                                        maskComposite: "exclude",
                                                                                    },
                                                                                }}
                                                                            >
                                                                                <Select
                                                                                    value={row.status}
                                                                                    onChange={(e) => handleChangeInput(index, e.target.value, "status")}
                                                                                    sx={{
                                                                                        width: "fit-content",
                                                                                        minWidth: "100px",
                                                                                        color: row?.status === "Accept" ? "#1ABC86" : row?.status === "Partially Accept" ? "#FF9807" : "#EF4444",
                                                                                        borderRadius: "30px",
                                                                                        "&.MuiOutlinedInput-root": {
                                                                                            borderRadius: "30px",
                                                                                        },
                                                                                        "& .MuiOutlinedInput-input": {
                                                                                            borderRadius: "30px",
                                                                                            padding: "6px 15px",
                                                                                        },
                                                                                        "& .MuiInputBase-input": {
                                                                                            backgroundColor: row?.status === "Accept" ? "#ECFDF5" : row?.status === "Partially Accept" ? "#FFF6E9" : "#FFEDED",
                                                                                            borderRadius: "30px",
                                                                                        },
                                                                                        "& .MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
                                                                                            borderRadius: "30px",
                                                                                        },
                                                                                        "& .MuiOutlinedInput-notchedOutline": {
                                                                                            border: "none",
                                                                                        },
                                                                                        "& .MuiSelect-icon": {
                                                                                            color: row?.status === "Accept" ? "#1ABC86" : row?.status === "Partially Accept" ? "#FF9807" : "#EF4444",
                                                                                        },
                                                                                    }}
                                                                                >
                                                                                    <MenuItem value="Accept">Accept</MenuItem>
                                                                                    <MenuItem value="Partially Accept">Partially Accept</MenuItem>
                                                                                    <MenuItem value="Reject">Reject</MenuItem>
                                                                                </Select>
                                                                            </Box>
                                                                        </FormControl>
                                                                    </Box>
                                                                </StyledTableCell>
                                                            </StyledTableRow>
                                                        </React.Fragment>
                                                    )
                                                })
                                                :
                                                <StyledTableRow>
                                                    <StyledTableCell colSpan={12}>
                                                        <NoDataFound />
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Grid>
                        {isAnyItemStatusPartiallyAcceptOrReject &&
                            <Grid item xs={12}>
                                <CommonTextField
                                    multiline
                                    rows={4}
                                    type="text"
                                    label="Remark"
                                    valid
                                    name="remark"
                                    value={selectedItem?.GRNDescription || ""}
                                    placeholder="Enter Remarks"
                                    onChange={(e) => setSelectedItem({ ...selectedItem, GRNDescription: e.target.value })}
                                />
                                <ErrorMessage text={!selectedItem?.GRNDescription ? error.remark : ""} />
                            </Grid>
                        }
                        <Grid item xs={12} mt={1} display={"flex"} gap={2}>
                            <Button className={classes.cancelButton} onClick={() => { setIsViewGrnNumber(false); setSelectedItem({}) }}>Cancel</Button>
                            {getPermissionList?.editPermission?.includes('Purchase Entry') &&
                                <Button className={classes.saveButton} onClick={() => _updatePurchaseEntry()}>Save </Button>
                            }
                        </Grid>
                    </Grid>
                </Box>
            </Grid >
        </Grid >
    )
}

export default ViewGrnNumber